import { useState } from "react";
import HTMLReactParser from "html-react-parser";
import classNames from "classnames";

import { CardsIcon, MoreIcon, TwoMoreIcon } from "../AscIcons";

import styles from "./AscAdminTrackStage.module.scss";
import AscAdminAction from "../AscAdminAction/AscAdminAction";
import AscParagraph from "../AscTypography/AscParagraph/AscParagraph";

export interface AscAdminTrackStageProps {
  className?: string;
  title: string;
  description: string;
  cards: number;
  stageNum?: number;
  stageImage?: string;
  onEdit: () => void;
  onRemove: () => void;
}

export default function AscAdminTrackStage({
  stageNum,
  className,
  title,
  description,
  cards,
  stageImage,
  onEdit,
  onRemove,
}: AscAdminTrackStageProps) {
  const [showAction, setShowAction] = useState<boolean>(false);

  const handleEdit = () => {
    onEdit();
    setShowAction(false);
  };

  const handleRemove = () => {
    onRemove();
    setShowAction(false);
  };

  return (
    <div
      data-testid="asc-admin-track-stage"
      className={classNames(styles.ground, className)}
    >
      <div className={styles.rightGround}>
        <TwoMoreIcon className={styles.twoMoreIcon} />
        {stageImage && (
          <img
            src={stageImage}
            alt={stageImage}
            className={styles.stageImage}
          />
        )}
      </div>

      <div className={styles.middleGround}>
        <AscParagraph className={styles.header}>
          Stage {stageNum}: {title}
        </AscParagraph>
        <div className={styles.title}>{HTMLReactParser(description)}</div>

        <div className={styles.cardsBlock}>
          <CardsIcon />
          <span>{cards} Cards</span>
        </div>
      </div>

      <div className={styles.leftGround}>
        <MoreIcon
          className={styles.moreIcon}
          onClick={() => setShowAction(!showAction)}
        />
        {showAction && (
          <AscAdminAction
            option1={"Edit"}
            option2={"Remove"}
            clickOption1={handleEdit}
            clickOption2={handleRemove}
            className={styles.actionBar}
          />
        )}
      </div>
    </div>
  );
}
